import dashboard from "@assets/images/dashboard.png";
import reports from "@assets/images/reports.png";
import consreports from "@assets/images/consreports.png"
import settings from "@assets/images/settings.png";
import user from "@assets/images/user.png";
import logout from "@assets/images/logout.png";
import svg from "@assets/images/svg2.png";
import device from "@assets/images/device.png";
import admin from "@assets/images/admin.png";

const options = [
  {
    key: "dashboard",
    label: "sidebar.dashboard",
    displayName: "sidebar.dashboard",
    leftIcon: dashboard,
    leftPosition: 24,
  },
  // {
  //   key: "svg",
  //   label: "sidebar.svg",
  //   displayName: "sidebar.svg",
  //   leftIcon: svg,
  //   leftPosition: 24,
  // },
  {
    key: "report",
    label: "sidebar.report",
    displayName: "sidebar.report.realtime",
    leftIcon: reports,
    leftPosition: 38,
  },
  {
    key: "consumption-report",
    label: "sidebar.consumptionreport",
    displayName: "sidebar.consumptionreport",
    leftIcon: consreports,
    leftPosition: 38,
  },
    {
    key: "device",
    label: "sidebar.device",
    displayName: "sidebar.device",
    leftIcon: device,
    leftPosition: 38,
  },
  {
    key: "settings",
    label: "sidebar.settings",
    displayName: "sidebar.settings",
    leftIcon: settings,
    leftPosition: 30,
  },
  {
    key: "profile",
    label: "sidebar.users",
    displayName: "sidebar.users",
    leftIcon: user,
    leftPosition: 24,
  },
  {
    key: "user-selection",
    label: "sidebar.userSelection",
    displayName: "sidebar.userSelection",
    leftIcon: admin,
    leftPosition: 24,
  },
  {
    key: "admin",
    label: "sidebar.admin",
    displayName: "sidebar.admin",
    leftIcon: admin,
    leftPosition: 24,
  },
  {
    key: "logout",
    label: "sidebar.logout",
    displayName: "sidebar.logout",
    leftIcon: logout,
    leftPosition: 36,
  },
];
export default options;
